import {
  THE_KYB_COUNTRY_CODES,
  getTheKybCountryCodeByCountryName,
} from "@/components/shared/constants/general.const";

/** ISO 3166-1 alpha-2 → regional indicator flag emoji (e.g. IN → 🇮🇳). */
export function regionalIndicatorFlagEmoji(alpha2: string): string | null {
  const c = alpha2.toUpperCase();
  if (c.length !== 2 || !/^[A-Z]{2}$/.test(c)) return null;
  const base = 0x1f1e6;
  const letterA = 0x41;
  return String.fromCodePoint(
    base + (c.charCodeAt(0) - letterA),
    base + (c.charCodeAt(1) - letterA)
  );
}

/** Resolve headquarters country display name to ISO alpha-2 when it matches KYB lists. */
export function isoAlpha2FromHeadquartersCountry(countryName?: string | null): string | null {
  const n = countryName?.trim();
  if (!n) return null;
  const row = THE_KYB_COUNTRY_CODES.find((c) => c.name === n);
  if (row) return row.code;
  return getTheKybCountryCodeByCountryName(n);
}

export function flagEmojiFromHeadquartersCountry(countryName?: string | null): string | null {
  const iso = isoAlpha2FromHeadquartersCountry(countryName);
  return iso ? regionalIndicatorFlagEmoji(iso) : null;
}
